import { createContext, useContext } from "react";

// Counter of usePersistedFormData restores that have landed on the enclosing
// form. Child effects that latch a "previous value" ref at mount can compare
// this against a locally-tracked "last seen" to detect and swallow the
// vendor-facing value change caused by an async form.reset(parsed).
export const HydrationContext = createContext<number>(0);

export function useHydrationCount(): number {
  return useContext(HydrationContext);
}
